import { Hourglass, Refresh as LoaderCircle } from "@papier/ui/components/icons";
import type { ComponentProps } from "react";

import { cn } from "@papier/ui/lib/utils";

// Switch icons with CSS so reduced motion is respected immediately and on preference changes.
function Spinner({ className, ...props }: ComponentProps<typeof LoaderCircle>) {
  return (
    <>
      <LoaderCircle
        aria-hidden="true"
        data-slot="spinner"
        className={cn(
          "size-4 shrink-0 origin-center animate-spin motion-reduce:hidden motion-reduce:animate-none",
          className,
        )}
        {...props}
      />
      <Hourglass
        aria-hidden="true"
        data-slot="spinner-static"
        className={cn("hidden size-4 shrink-0 motion-reduce:block", className)}
        {...props}
      />
    </>
  );
}

export { Spinner };
